<coop-good-price-form
  [editMode]="true"
  [templateMode]="false"
  [formData]="formData"
></coop-good-price-form>
